import { Skeleton } from "@mui/material";

const InputSkeleton = () => {
    return <Skeleton animation="wave" variant="text" sx={{ fontSize: '1', margin: "10px 0", height: '30px', width: "100%" }} />
}

export default InputSkeleton;